import { useI18n } from '~/scripts/composables/useI18n'
import { defineMagic } from '~/scripts/utils/alpine'

export default defineMagic(() => useI18n())

// Declare $i18n as a magic property
declare module 'alpinejs' {
  // eslint-disable-next-line unused-imports/no-unused-vars
  export interface Magics<T> {
    $i18n: ReturnType<typeof useI18n>
  }
}
